/** 미션펀드 공식 사이트 — 개인정보 처리방침 */
export const MISSIONFUND_PRIVACY_POLICY_URL =
  'https://missionfund.org/missionfund_service_policy.asp';

/** 미션펀드 공식 사이트 — 서비스 이용 약관 및 운용지침 */
export const MISSIONFUND_TERMS_OF_SERVICE_URL =
  'https://missionfund.org/missionfund_terms_of_service.asp';

/** 미션펀드 공식 사이트 — 모금지원 상담 */
export const MISSIONFUND_SUPPORT_URL = 'https://missionfund.org/support/';
